import React, { useState } from 'react';
import { IProps } from './types';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { setSelectVehicleBrandsModalVisibleAction } from 'redux/actions/modal.action';
import { RootReducersState } from 'redux/reducers';
import Modal from 'components/Modal';
import _ from 'lodash';
import { VehicleBrand } from 'bff/models/product';

const SelectVehicleBrandsModal: React.FC<IProps> = (props) => {
  const [searchVal, setSearchVal] = useState('');

  const handleClose = (selectItem?:VehicleBrand) => {
    setSearchVal('');
    props.setSelectVehicleBrandsModalVisible(false, new Array(0), selectItem);
  };

  /**
   * @description 建立字母分組
  */
  const handleVehicleGroup = (vehicleBrands:VehicleBrand[]) => {
    if (!vehicleBrands || vehicleBrands.length === 0) return;

    const letterReg = /^[A-Z]$/;

    const res:any = new Array(0);
    // res['其他'] = new Array(0);
    _.forEach(vehicleBrands, (brand:VehicleBrand, index:number) => {
      // 字母首字轉大寫
      let letter = (brand.TI_NAME).substr(0, 1).toUpperCase();
      // 判斷是否為英文
      if (!letterReg.test(letter)) {
        letter = '其他';
      }

      // 建立字母分組
      if (!(letter in res)) {
        res[letter] = new Array(0);
      }

      res[letter].push(brand);
    });

    const result = new Array(0);
    for (const key in res) {
      result.push({
        letter: key,
        list: res[key] as VehicleBrand
      });
    }

    result.sort((x:any, y:any) => {
      return x.letter.charCodeAt(0) - y.letter.charCodeAt(0);
    });

    return result;
  };

  /**
   * @description 篩選搜尋結果
  */
  const handleFilterSearchVal = (searchVal:string, vehicleBrands:VehicleBrand[]) => {
    const isAlphabet = /^[a-zA-z\s]+$/.test(searchVal);
    if (isAlphabet) {
      return _.filter(vehicleBrands, (vehicleBrand:VehicleBrand) => {
        return vehicleBrand.TI_NAME.toUpperCase().startsWith(searchVal.toUpperCase());
      });
    }
    return _.filter(vehicleBrands, (vehicleBrand:VehicleBrand) => {
      return vehicleBrand.TI_NAME.toUpperCase().indexOf(searchVal.toUpperCase()) !== -1;
    });
  };

  /**
   * @description 建立車輛選單
  */
  const handleCreateList = (vehicleGroup:any) => {
    const childs = new Array(0);
    _.forEach(vehicleGroup, (group:any, groupIndex:number) => {
      const letter = <div className="select-vehicle-brands-modal__brands-part-title" key={groupIndex}>{group.letter}</div>;
      const brands = (
        <div className="select-vehicle-brands-modal__brands-part-content" key={`${groupIndex}${group.letter}`}>
          {_.map(group.list, (brand:VehicleBrand, brandIndex:number) => {
            return (
              <div
                className="select-vehicle-brands-modal__brand-item"
                key={brandIndex}
                onClick={() => handleClose(brand)}
              >
                <div className="select-vehicle-brands-modal__brand-logo" style={{ backgroundImage: brand.BLOGO ? `url(${brand.BLOGO})` : `url(${require('assets/images/vehicle-default-logo.png')})` }} />
                <span>{brand.TI_NAME}</span>
              </div>
            );
          })}
        </div>
      );

      childs.push(
        React.cloneElement(
          <div className="select-vehicle-brands-modal__brands-part">
            {letter}
            {brands}
          </div>
          , { key: `${group.letter}` }
        )
      );
    });

    return childs;
  };

  // #region 建立車輛選單
  let brandList;
  if (props.modal.selectVehicleBrandsModalState.vehicleBrands && props.modal.selectVehicleBrandsModalState.vehicleBrands.length > 0) {
    let vehicleBrands = [...props.modal.selectVehicleBrandsModalState.vehicleBrands];
    if (searchVal) {
      vehicleBrands = handleFilterSearchVal(searchVal, props.modal.selectVehicleBrandsModalState.vehicleBrands);
    }

    const groupsRes = handleVehicleGroup(vehicleBrands);
    brandList = handleCreateList(groupsRes);
  }
  // #endregion

  return (
    <>
      {props.modal.selectVehicleBrandsModalState.visible &&
        props.modal.selectVehicleBrandsModalState.vehicleBrands &&
        props.modal.selectVehicleBrandsModalState.vehicleBrands.length > 0 &&
        (
          <div className="select-vehicle-brands-modal">
            <Modal
              visible={props.modal.selectVehicleBrandsModalState.visible}
              title="選擇廠牌"
              confirmButton={false}
              onCancel={handleClose}
            >
              <div className="select-vehicle-brands-modal__search">
                <input
                  type="text"
                  className="select-vehicle-brands-modal__search-input"
                  placeholder="搜尋..."
                  onChange={(e:React.ChangeEvent<HTMLInputElement>) => setSearchVal(e.currentTarget.value)}
                />
              </div>
              <div className="select-vehicle-brands-modal__brands-list">
                {brandList}
              </div>
            </Modal>
          </div>
        )}
    </>
  );
};

const mapStateToProps = (state: RootReducersState) => ({
  modal: state.modal
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setSelectVehicleBrandsModalVisible:
    (visible: boolean, vehicleBrands?:VehicleBrand[], selectItem?:VehicleBrand) =>
      dispatch(setSelectVehicleBrandsModalVisibleAction(visible, vehicleBrands, selectItem))
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectVehicleBrandsModal);
